import React from 'react';
import { useLocation } from 'react-router-dom';
import { Title } from './Title'
import Store from '../../store/Store';

export interface BodyProps {
    id?: string;
    center?: boolean;
    title?: string;
    subTitle?: string;
    children?: React.ReactNode;
}

export const Body: React.FC<BodyProps> = (props) => {
    const location = useLocation();
    const isDashboard = location.pathname === '/dashboard';
    const isProvider = Store.mode === 'PROVIDER';

    let marginTop = '50px';
    if (isProvider) {
        marginTop = '45px';
    } else if (isDashboard && !isProvider) {
        marginTop = '320px';
    }
    return (
        <div
            className={
                'page-body relative' + (props.center ? ' justify-center' : '')
            }
            id={props.id}
            style={{ marginTop }}
        >
            <div className="page-content">
                {(props.title ?? props.subTitle) && (
                    <Title>
                        {props.title}
                        <span>{props.subTitle}</span>
                    </Title>
                )}
                {props.children}
            </div>
        </div>
    );
};
